import { Book, List, Package } from 'lucide-react';

import { useAppSelector } from 'app/store';
import { selectUserInfo } from 'app/store/user';
import { ACTION, SOURCE } from 'app/analytics';
import { trackSegmentEvent } from 'app/utils';
import config from 'config/constants';
import { isLegacyBilling } from 'lib/utils';

import { Typography } from 'components/ui/typography';
import { ProjectCard } from 'pages/Dashboard/components/ProjectCard';

const track = (label: string) =>
  trackSegmentEvent(SOURCE.DEVELOPER_RESOURCES_MODULE, ACTION.CLICK, label);

const Page = () => {
  const { billingPeriodSettings } = useAppSelector(selectUserInfo) || {};
  // Legacy accounts still ship against the v1 GraphQL docs; modern accounts
  // get the v2 site that covers Checkout Intents.
  const docsUrl = isLegacyBilling(billingPeriodSettings)
    ? config.external.doc.home
    : config.external.doc.homeV2;

  const resources = [
    {
      title: 'Developer Documentation',
      description: 'Learn how to use the Rye API. See common queries and how the API functions.',
      url: docsUrl,
      icon: Book,
      onClick: () => track('dev_docs_link'),
    },
    {
      title: 'SDKs',
      description: 'Method-by-method reference for the Checkout Intents SDK.',
      url: 'https://docs.rye.com/api-v2/sdk',
      icon: Package,
      onClick: () => track('sdk_reference_link'),
    },
    {
      title: 'Sell Anything API Brands',
      description: 'Contact us for the list of Sell Anything API brands and commissions.',
      url: 'mailto:support@rye.com',
      icon: List,
      onClick: () => track('view_sell_anything_spreadsheet'),
    },
  ];

  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <div>
        <Typography variant="h2" as="h1" className="mb-2">
          Developer Resources
        </Typography>
        <Typography variant="lede" as="p">
          Documentation, SDKs, and starter data for building on Rye.
        </Typography>
      </div>
      <div className="grid auto-rows-fr grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {resources.map((resource) => (
          <ProjectCard key={resource.title} {...resource} />
        ))}
      </div>
    </div>
  );
};

export default Page;
